<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <!-- 返回按钮和题目信息 -->
          <div v-if="$route.query.questionId" style="margin-bottom: 10px; padding: 10px; background: #f5f7fa; border-radius: 4px;">
            <el-button 
              size="small" 
              icon="el-icon-arrow-left" 
              @click="goBack"
              style="margin-right: 10px;"
            >
              返回题目列表
            </el-button>
            <span style="color: #666; font-size: 14px;">
              当前查看题目：<strong>{{ $route.query.questionName || '未知题目' }}</strong> (ID: {{ $route.query.questionId }})
            </span>
          </div>
          
          <template>
            <el-select
                v-model="search.questionId"
                clearable
                filterable
                placeholder="选择题目"
                style="margin-bottom: 10px;margin-right: 10px"
                @change="SearchServiceList"
            >
              <el-option
                  v-for="item in questionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>

            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
            <el-button size="medium" @click="handleReset"
            >重置</el-button
            >
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="handleAdd"
          >新增答案</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <!-- 未选择题目时的提示 -->
          <div v-if="!search.questionId" style="text-align: center; padding: 40px; color: #999;">
            <i class="el-icon-info" style="font-size: 48px; margin-bottom: 16px;"></i>
            <div style="font-size: 16px;">请先选择题目查看对应的答案列表</div>
          </div>
          
          <el-table
            v-else
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="80">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="答案信息" min-width="300">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; text-align: left;">
                  <div style="width: 40px; height: 40px; margin-right: 10px; flex-shrink: 0;" v-if="scope.row.icon">
                    <img 
                      :src="scope.row.icon" 
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;"
                    />
                  </div>
                  <div style="flex: 1;">
                    <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                      {{ scope.row.name || '-' }}
                    </div>
                    <div style="color: #666; font-size: 12px; margin-bottom: 3px;">
                      布局视图：{{ scope.row.view || '-' }}
                    </div>
                    <div style="color: #666; font-size: 12px; margin-bottom: 3px;">
                      答题方式：{{ scope.row.answerWay || '-' }}
                    </div>
                    <div style="color: #666; font-size: 12px;">
                      {{ scope.row.description || '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="题目信息" min-width="200">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                    {{ getQuestionName(scope.row.questionId) || '-' }}
                  </div>
                  <!-- <div style="color: #666; font-size: 12px;">
                    题目ID：{{ scope.row.questionId || '-' }}
                  </div> -->
                </div>
              </template>
            </el-table-column>

            <el-table-column label="正确答案" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isRight === 1 ? 'success' : 'info'" size="mini">
                  {{ scope.row.isRight === 1 ? '正确' : '错误' }}
                </el-tag>
              </template>
            </el-table-column>

            <!-- <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isOffline === 0 ? 'success' : 'danger'" size="mini">
                  {{ scope.row.isOffline === 0 ? '上架' : '下架' }}
                </el-tag>
              </template>
            </el-table-column> -->

            <el-table-column label="排序" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.sortOrder"
                  type="number"
                  valueKey="sortOrder"
                  customApi="/question/answer/save"
                  :disabled="!editShow"
                  :params="scope.row"
                  @refresh="getQuestionList"
                />
              </template>
            </el-table-column>
            <el-table-column label="上架" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.isOffline"
                  valueKey="isOffline"
                  customApi="/question/answer/save"
                  :active-value="0"
                  :inactive-value="1"
                  activeColor="#13ce66"
                  inactiveColor="#ff4949"
                  :disabled="!statusShow"
                  :params="scope.row"
                  @refresh="getQuestionList"
                />
              </template>
            </el-table-column>

            <el-table-column label="时间信息" min-width="180">
              <template slot-scope="scope">
                <div style="font-size: 12px;">
                  <div>创建：{{ formatDate(scope.row.ctime) }}</div>
                  <div>更新：{{ formatDate(scope.row.utime) }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  v-if="editShow"
                >
                  编辑
                </el-button>

                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  v-if="detailShow"
                >
                  详情
                </el-button>

                <el-button
                  @click="handleDelete(scope.row)"
                  type="text"
                  size="small"
                  style="color: #f56c6c"
                  v-if="deleteShow"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="roleRight_pagenation" v-if="search.questionId">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <MultiLanguageDetailDialog
      ref="detailDialog"
      title="答案详情"
      detail-api="question/answer/detail"
      width="800px"
    />

    <!-- 编辑弹窗 -->
    <MultiLanguageEditDialog
      ref="editDialog"
      title="答案编辑"
      detail-api="question/answer/detail"
      :api="'/question/answer/save'"
      @success="getAnswerList"
    />
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  VIEW_OPTIONS,
  ANSWER_WAY_OPTIONS,
  CORRECT_OPTIONS
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import MultiLanguageDetailDialog from "@/components/MultiLanguageDetailDialog.vue";
import MultiLanguageEditDialog from '@/components/MultiLanguageEditDialog.vue';
import InlineTableControler from '@/components/InlineTableControler.vue';

export default {
  components: {
    MultiLanguageDetailDialog,
    MultiLanguageEditDialog,
    InlineTableControler
  },
  data() {
    return {
      PAGE_SIZE,
      formatDate,      
      // 正确性选项
      CORRECT_OPTIONS,
      VIEW_OPTIONS,
      ANSWER_WAY_OPTIONS, 
     // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
        count: 0
      },
      
      questionList: [], // 题目列表
      tableData: [], // 答案列表数据
      loading: false,
      search: {},

      // 权限控制
      searchShow: true,
      addShow: true,
      editShow: true,
      deleteShow: true,
      statusShow: true,
      detailShow: true
    };
  },
  created() {
    this.getQuestionList();
    
    // 检查路由参数，如果有questionId则自动设置并查询
    if (this.$route.query.questionId) {
      this.search.questionId = parseInt(this.$route.query.questionId);
      // 等待题目列表加载完成后再查询答案
      this.$nextTick(() => {
        this.getAnswerList();
      });
    }
    
    this.getPermissionButtonList();
  },
  methods: {
    // 获取题目列表
    async getQuestionList() {
      try {
        const { data: res } = await this.$post(
          `/question/info/list`,
          { 
            pageNo: 1, 
            pageSize: 1000 
          }
        );
        if (res && res.data) {
          this.questionList = res.data.records || res.data;
        }
      } catch (error) {
        console.error('获取题目列表失败:', error);
      }
    },

    // 根据题目ID获取题目名称
    getQuestionName(questionId) {
      if (!questionId || !this.questionList) return '';
      const question = this.questionList.find(q => q.id === questionId);
      return question ? question.name : '';
    },

    // 获取权限按钮列表
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
      if (PermissionButtonList) {
        try {
          let arr = JSON.parse(PermissionButtonList);
          if (arr && Array.isArray(arr) && arr.length) {
            arr.forEach(item => {
              if (item.code === 'question:answer:query') {
                this.searchShow = true;
              }
              if (item.code === 'question:answer:add') {
                this.addShow = true;
              }
              if (item.code === 'question:answer:edit') {
                this.editShow = true;
              }
              if (item.code === 'question:answer:delete') {
                this.deleteShow = true;
              }
              if (item.code === 'question:answer:status') {
                this.statusShow = true;
              }
              if (item.code === 'question:answer:detail') {
                this.detailShow = true;
              }
            });
          }
        } catch (error) {
          console.error('权限按钮列表解析失败:', error);
        }
      }
    },

    // 搜索
    SearchServiceList() {
      this.page.pageNo = 1;
      this.getAnswerList();
    },

    // 获取答案列表
    async getAnswerList() {
      // 如果没有选择题目，则不发送请求
      // if (!this.search.questionId) {
      //   this.tableData = [];
      //   this.page.count = 0;
      //   return;
      // }

      this.loading = true;
      try {
        const { data: res } = await this.$post(
          `/question/answer/list`,
          { 
            ...this.search, 
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize
          },
          {
            headers: {
              isLoading: true,
            },
          }
        );
        
        if (res && res.data) {
          this.tableData = res.data;
          // 根据接口返回格式，page对象包含分页信息
          if (res.page) {
            this.page.count = res.page.count || 0;
          }
        }
      } catch (error) {
        console.error('获取答案列表失败:', error);
        this.$message.error('获取答案列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 新增答案
    handleAdd() {
      if (!this.$refs.editDialog) return;
      // 通过当前选中的题目ID找到题目信息
      const question = this.questionList.find(q => q.id === this.search.questionId);
      if (!question || !question.view || !question.answerWay) {
        this.$message.error('请先编辑题目的布局和答题方式');
        return;
      }
      const addData = {
        questionId: this.search.questionId,
        view: question.view,
        answerWay: question.answerWay
      };
      this.$refs.editDialog.open(addData, this.getBasicColumns(), { api: '/question/answer/save', method: 'post' });
    },

    // 编辑答案
    handleEdit(row) {
      if (!this.$refs.editDialog) return;
      // 通过题目ID找到题目信息
      const question = this.questionList.find(q => q.id === row.questionId);
      // 优先用 row 里的值，没有就用题目里的
      const editData = {
        ...row,
        view: row.view || (question && question.view),
        answerWay: row.answerWay || (question && question.answerWay)
      };
      if (!editData.view || !editData.answerWay) {
        this.$message.error('请先编辑题目的布局和答题方式');
        return;
      }
      this.$refs.editDialog.open(editData, this.getBasicColumns(), { api: '/question/answer/save', method: 'post' });
    },

    // 查看详情
    async handleDetail(row) {
      // 检查ref是否存在
      if (!this.$refs.detailDialog) {
        console.error('DetailDialog组件未找到');
        this.$message.error('详情组件加载失败，请刷新页面重试');
        return;
      }

      // 定义答案详情列配置
      const detailColumns = [
        // { label: '答案ID', prop: 'id', type: 'text' },
        // { label: '题目ID', prop: 'questionId', type: 'text' },
        { label: '题目名称', prop: 'questionName', type: 'text', span: 2, computed: (row) => this.getQuestionName(row.questionId) },
        { label: '答案图标', prop: 'icon', type: 'image' },
        { label: '答案名称', prop: 'name', type: 'text' },
        { label: '答案描述', prop: 'description', type: 'text', span: 2 },
        { label: '布局视图', prop: 'view', type: 'tag', tagMap: {
          ve1: { text: '列表形', type: 'success' },
          ve2: { text: '田字形', type: 'info' }
        }},
        { label: '答题方式', prop: 'answerWay', type: 'tag', tagMap: {
          sel1: { text: '单选', type: 'success' },
          sel2: { text: '多选', type: 'info' },
          gap: { text: '填空题', type: 'danger' }
        }},
        { label: '是否正确', prop: 'isRight', type: 'tag', tagMap: {
          0: { text: '错误答案', type: 'info' },
          1: { text: '正确答案', type: 'success' }
        }},
        { label: '排序', prop: 'sortOrder', type: 'text' },
        { label: '状态', prop: 'isOffline', type: 'tag', tagMap: {
          0: { text: '上架', type: 'success' },
          1: { text: '下架', type: 'danger' }
        }},
        { label: '创建时间', prop: 'ctime', type: 'date' },
        { label: '更新时间', prop: 'utime', type: 'date' },
      ];

      this.$refs.detailDialog.open(row, detailColumns);
    },

    // 删除答案
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这个答案吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口
        await this.$get(`/question/answer/delete/${row.id}`);
        this.$message.success('删除成功');
        this.getAnswerList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },

    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getAnswerList();
    },
    
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getAnswerList();
    },

    // 重置搜索条件
    handleReset() {
      this.search = {};
      this.page.pageNo = 1;
      this.getAnswerList();
    },

    getBasicColumns() {
      // 自定义校验规则，允许0和1都通过
      const isRightValidator = (rule, value, callback) => {
        if (value === 0 || value === 1) {
          callback();
        } else {
          callback(new Error('请选择是否正确'));
        }
      };
      return [
        // { label: 'ID', prop: 'id', type: 'text', addHide: true },
        { label: '题目', prop: 'questionId', type: 'select', options: this.questionList, required: true,disabled:true },
        { label: '答案图标', prop: 'icon', type: 'image' },
        { label: '答案名称', prop: 'name', type: 'text', required: true },
        { label: '布局视图', prop: 'view', type: 'select', options: this.VIEW_OPTIONS, disabled: true },
        { label: '答题方式', prop: 'answerWay', type: 'select', options: this.ANSWER_WAY_OPTIONS, disabled: true },
        { label: '答案描述', prop: 'description', type: 'textarea' },
        { label: '是否正确', prop: 'isRight', type: 'select', options: this.CORRECT_OPTIONS, required: true },
        { label: '排序', prop: 'sortOrder', type: 'number' },
        { label: '是否下架', prop: 'isOffline', type: 'switch' },
        // { label: '是否删除', prop: 'isDelete', type: 'switch', addHide: true },
        // { label: '创建时间', prop: 'ctime', type: 'date', hide: true, addHide: true, editHide: true },
        // { label: '更新时间', prop: 'utime', type: 'date', hide: true, addHide: true, editHide: true }
      ];
    },

    // 返回题目列表
    goBack() {
      this.$router.push({ name: 'DAILY_QUESTION_MANAGEMENT_LIST' });
    }
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>